'use strict';
module.exports = function removeFalsyProperties(value) {
	if (Number.isFinite(value)) {
		return value;
	}
	if (!value) {
		return false;
	}
	if (typeof (value) !== 'object') {
		return value;
	}
	const result = {};
	Object.keys(value).forEach(key => {
		if (value.hasOwnProperty(key)) {
			const cleaned = removeFalsyProperties(value[key]);
			if (Number.isFinite(cleaned) || cleaned) {
				result[key] = cleaned;
			}
		}
	});
	if (Object.keys(result).length === 0) {
		return false;
	}
	return result;
};
